module.exports = __webpack_public_path__ + "fonts/fontagon-icons.9aec84e.eot";